import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#003366', textAlign: 'center', marginBottom: '30px' }}>Πολιτική Επιστροφών και Χρημάτων</h1>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>1. Γενικές Αρχές</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Η Halecor Μουσική Σχολή δεσμεύεται να παρέχει υπηρεσίες υψηλής ποιότητας. Κατανοούμε 
          ότι ενδέχεται να προκύψουν περιστάσεις που απαιτούν ακύρωση ή επιστροφή χρημάτων. 
          Αυτή η πολιτική εξηγεί τους όρους και τις προϋποθέσεις για επιστροφές χρημάτων.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>2. Περίοδος Δοκιμαστικού Μαθήματος</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Προσφέρουμε ένα δοκιμαστικό μάθημα σε προνομιακή τιμή για νέους μαθητές. Εάν δεν είστε 
          ικανοποιημένοι μετά το πρώτο μάθημα, μπορείτε να ζητήσετε πλήρη επιστροφή χρημάτων 
          εντός 48 ωρών. Αυτό ισχύει μόνο για το πρώτο δοκιμαστικό μάθημα και όχι για ολόκληρα 
          πακέτα μαθημάτων.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>3. Ακύρωση Πακέτων Μαθημάτων</h2>
        
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#003366', fontSize: '18px', marginBottom: '10px' }}>3.1 Ακύρωση πριν την έναρξη</h3>
          <p style={{ lineHeight: '1.8', color: '#333' }}>
            Εάν ακυρώσετε το πακέτο μαθημάτων πριν παρακολουθήσετε το πρώτο μάθημα:
          </p>
          <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginTop: '10px' }}>
            <li>Περισσότερο από 7 ημέρες πριν: Πλήρης επιστροφή χρημάτων (100%)</li>
            <li>3-7 ημέρες πριν: Επιστροφή 80% του ποσού</li>
            <li>1-2 ημέρες πριν: Επιστροφή 50% του ποσού</li>
            <li>Λιγότερο από 24 ώρες: Χωρίς επιστροφή χρημάτων</li>
          </ul>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#003366', fontSize: '18px', marginBottom: '10px' }}>3.2 Ακύρωση μετά την έναρξη</h3>
          <p style={{ lineHeight: '1.8', color: '#333' }}>
            Εάν έχετε ήδη ξεκινήσει τα μαθήματα και επιθυμείτε να ακυρώσετε:
          </p>
          <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginTop: '10px' }}>
            <li>Μετά το 1ο μάθημα: Επιστροφή για τα μη παρακολουθημένα μαθήματα μείον 20% διοικητικό κόστος</li>
            <li>Μετά το 2ο-3ο μάθημα: Επιστροφή για τα μη παρακολουθημένα μαθήματα μείον 30% διοικητικό κόστος</li>
            <li>Μετά το 4ο μάθημα ή 50% ολοκλήρωση: Χωρίς επιστροφή χρημάτων</li>
          </ul>
        </div>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>4. Ειδικές Περιπτώσεις Επιστροφής</h2>
        
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#003366', fontSize: '18px', marginBottom: '10px' }}>4.1 Ιατρικοί Λόγοι</h3>
          <p style={{ lineHeight: '1.8', color: '#333' }}>
            Σε περίπτωση σοβαρής ασθένειας ή τραυματισμού που εμποδίζει τη συνέχιση των μαθημάτων:
          </p>
          <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginTop: '10px' }}>
            <li>Απαιτείται ιατρική βεβαίωση</li>
            <li>Επιστροφή 100% για τα μη παρακολουθημένα μαθήματα</li>
            <li>Εναλλακτικά: Μεταφορά του υπολοίπου σε μελλοντικό εξάμηνο (έως 12 μήνες)</li>
          </ul>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#003366', fontSize: '18px', marginBottom: '10px' }}>4.2 Μετεγκατάσταση</h3>
          <p style={{ lineHeight: '1.8', color: '#333' }}>
            Σε περίπτωση μετακόμισης σε άλλη πόλη:
          </p>
          <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginTop: '10px' }}>
            <li>Απαιτείται απόδειξη μετεγκατάστασης (π.χ. συμβόλαιο ενοικίασης, λογαριασμοί κοινής ωφέλειας)</li>
            <li>Επιστροφή 90% για τα μη παρακολουθημένα μαθήματα</li>
            <li>Δυνατότητα συνέχισης με online μαθήματα χωρίς επιπλέον κόστος</li>
          </ul>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#003366', fontSize: '18px', marginBottom: '10px' }}>4.3 Ακύρωση από τη Σχολή</h3>
          <p style={{ lineHeight: '1.8', color: '#333' }}>
            Εάν η Halecor ακυρώσει μαθήματα για οποιονδήποτε λόγο:
          </p>
          <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px', marginTop: '10px' }}>
            <li>Πλήρης επιστροφή χρημάτων (100%)</li>
            <li>Ή αναπρογραμματισμός σε συμφωνημένη ημερομηνία</li>
            <li>Πιθανή προσφορά επιπλέον δωρεάν μαθήματος ως αποζημίωση</li>
          </ul>
        </div>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>5. Μεμονωμένα Μαθήματα</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Για μεμονωμένα μαθήματα (όχι πακέτα):
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Ακύρωση 24+ ώρες πριν: Πλήρης επιστροφή ή αναπρογραμματισμός</li>
          <li>Ακύρωση 12-24 ώρες πριν: Επιστροφή 50% ή αναπρογραμματισμός</li>
          <li>Ακύρωση εντός 12 ωρών: Χωρίς επιστροφή</li>
          <li>Μη εμφάνιση: Χωρίς επιστροφή</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>6. Online Μαθήματα</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Για online μαθήματα ισχύουν οι ίδιοι όροι με τα δια ζώσης μαθήματα, με τις εξής εξαιρέσεις:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Τεχνικά προβλήματα από την πλευρά της σχολής: Πλήρης επαναδιεξαγωγή μαθήματος</li>
          <li>Τεχνικά προβλήματα από την πλευρά του μαθητή: Χωρίς επιστροφή, εκτός αν διαρκούν >50% του μαθήματος</li>
          <li>Κακή ποιότητα σύνδεσης: Αποφασίζεται case-by-case</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>7. Workshops και Ειδικές Εκδηλώσεις</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Για workshops, σεμινάρια και ειδικές εκδηλώσεις:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Ακύρωση 14+ ημέρες πριν: Επιστροφή 100%</li>
          <li>Ακύρωση 7-14 ημέρες πριν: Επιστροφή 70%</li>
          <li>Ακύρωση 3-7 ημέρες πριν: Επιστροφή 50%</li>
          <li>Ακύρωση εντός 3 ημερών: Χωρίς επιστροφή</li>
          <li>Δυνατότητα μεταφοράς εισιτηρίου σε άλλο άτομο με προειδοποίηση 24 ωρών</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>8. Ενοικίαση Αιθουσών</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Για ενοικίαση μουσικών αιθουσών:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Ακύρωση 48+ ώρες πριν: Πλήρης επιστροφή</li>
          <li>Ακύρωση 24-48 ώρες πριν: Επιστροφή 50%</li>
          <li>Ακύρωση εντός 24 ωρών: Χωρίς επιστροφή</li>
          <li>Για μηνιαία πακέτα ενοικίασης: Επιστροφή αναλογικά για μη χρησιμοποιημένες ώρες μείον 20%</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>9. Διαδικασία Αίτησης Επιστροφής</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Για να ζητήσετε επιστροφή χρημάτων:
        </p>
        <ol style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Στείλτε email στο <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a> με:
            <ul style={{ marginTop: '5px', marginBottom: '10px' }}>
              <li>Ονοματεπώνυμο και στοιχεία επικοινωνίας</li>
              <li>Αριθμό παραγγελίας/εγγραφής</li>
              <li>Λόγο επιστροφής</li>
              <li>Σχετικά έγγραφα (αν απαιτούνται)</li>
            </ul>
          </li>
          <li>Θα λάβετε επιβεβαίωση εντός 2 εργάσιμων ημερών</li>
          <li>Η αξιολόγηση ολοκληρώνεται εντός 5 εργάσιμων ημερών</li>
          <li>Εάν εγκριθεί, η επιστροφή πραγματοποιείται εντός 10-14 εργάσιμων ημερών</li>
        </ol>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>10. Μέθοδοι Επιστροφής</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Οι επιστροφές πραγματοποιούνται με την ίδια μέθοδο πληρωμής:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Πιστωτική/χρεωστική κάρτα: 5-10 εργάσιμες ημέρες</li>
          <li>Τραπεζική μεταφορά: 3-5 εργάσιμες ημέρες</li>
          <li>Μετρητά: Άμεση επιστροφή στο γραφείο μας</li>
          <li>Πίστωση λογαριασμού: Άμεση εφαρμογή για μελλοντικά μαθήματα</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>11. Εξαιρέσεις - Χωρίς Επιστροφή</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Δεν παρέχεται επιστροφή χρημάτων στις ακόλουθες περιπτώσεις:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Αλλαγή γνώμης μετά την ολοκλήρωση 50% του πακέτου</li>
          <li>Παραβίαση των όρων χρήσης που οδηγεί σε τερματισμό</li>
          <li>Προσφορές και εκπτωτικά πακέτα (εκτός συγκεκριμένων όρων)</li>
          <li>Μη εμφάνιση χωρίς προειδοποίηση</li>
          <li>Αγορά μουσικών οργάνων ή εξοπλισμού (διέπονται από ξεχωριστή πολιτική)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>12. Μεταφορά Μαθημάτων</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Αντί για επιστροφή χρημάτων, μπορείτε να επιλέξετε:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Μεταφορά σε άλλο μέλος της οικογένειας</li>
          <li>Αναστολή και συνέχιση εντός 12 μηνών</li>
          <li>Μετατροπή σε online μαθήματα</li>
          <li>Αλλαγή οργάνου ή καθηγητή</li>
          <li>Πίστωση για άλλες υπηρεσίες της σχολής (workshops, εκδηλώσεις)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>13. Διαφορές και Παράπονα</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Εάν δεν είστε ικανοποιημένοι με την απόφαση επιστροφής:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Μπορείτε να ζητήσετε αναθεώρηση στέλνοντας αιτιολογημένο αίτημα</li>
          <li>Η αναθεώρηση γίνεται από ανώτερο στέλεχος εντός 7 ημερών</li>
          <li>Η τελική απόφαση γνωστοποιείται γραπτώς</li>
          <li>Διατηρείτε το δικαίωμα προσφυγής στις αρμόδιες καταναλωτικές αρχές</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>14. Επικοινωνία</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Για ερωτήσεις σχετικά με επιστροφές χρημάτων:
        </p>
        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '10px' }}>
          <strong>Email:</strong> <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a><br />
          <strong>Τηλέφωνο:</strong> +30 210 1234567<br />
          <strong>Γενικό Email:</strong> <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a><br />
          <strong>Διεύθυνση:</strong> Οδός Μουσικής 123, Αθήνα 10678, Ελλάδα<br />
          <strong>Ώρες λειτουργίας:</strong> Δευτέρα - Παρασκευή: 09:00 - 21:00, Σάββατο: 10:00 - 18:00
        </p>
      </section>

      <section style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
        <p style={{ lineHeight: '1.8', color: '#666', fontSize: '14px', textAlign: 'center' }}>
          Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}<br />
          Η Halecor διατηρεί το δικαίωμα να τροποποιεί αυτήν την πολιτική. Οι αλλαγές ισχύουν από τη στιγμή δημοσίευσής τους.<br />
          Παρακαλούμε διαβάστε προσεκτικά πριν την εγγραφή σας.
        </p>
      </section>
    </div>
  
    </>);
};

export default RefundPolicy;